import { TemplatePage } from './types';

const live_streaming_countdown_page: TemplatePage = {
  header: {
    color: '#FDF5E0',
    icon: 'images/video-templates/countdown.jpg',
    title: 'Live Stream Countdown Timer Templates',
    title_meta: '20+ Live Stream Countdown Timer Templates',
    description_meta:
      'Set the right tone for your live video with Wave.video’s editable live stream countdown timer templates. ' +
      'Grab viewers’ attention from the very first seconds.',
    description:
      'Set the right tone for your live video with our editable live stream countdown timer templates. Build up ' +
      'anticipation for your show and grab viewers’ attention from the very first seconds.'
  },
  footer: {
    category: 'Live streaming countdown',
    description:
      'With Wave.video’s collection of customizable video templates, you will easily make your live streams more ' +
      'professional-looking and engaging. Just select a template that fits your needs best, customize it to your ' +
      'taste and branding, and start growing your viewership right away.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming countdown',
      search: { name: 'LiveCountdown', tags: 'LiveCountdown' }
    },
    {
      type: 'stocks',
      title: 'countdown',
      search: { name: 'countdown' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_countdown_page;
